import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Takaisin',
      changePassword: 'Vaihda salasana',
      copiedVaultId: 'Kopioitu!',
      copyVaultID: 'Kopioi Vault ID',
      create: 'Luo',
      next: 'Seuraava',
      notSure: 'En ole varma',
      signUp: 'Rekisteröidy',
      submit: 'Lähetä',
      updatePassword: 'Päivitä salasana',
    },
    Errors: {
      createReportFailed: 'Raportin luonti epäonnistui.',
    },
    ReportStatus: {
      CLOSED: 'Suljettu',
      INVESTIGATING: 'Tutkitaan',
      NEW: 'Lähetetty',
      READ: 'Luettu',
    },
    general: {
      navbar: {
        caseSettings: 'Tapausasetukset',
        changePassword: 'Vaihda salasana',
        logOut: 'Kirjaudu ulos',
        notifications: 'Ilmoitukset',
        notificationsDrawer: {
          appFileScanFailed: 'Tiedosto on epäonnistunut turvatarkastuksessa',
          appReportMatch: 'GoTogether-tietueesi on tarkistettu',
          appReportReassigned: 'Uusi tapauksenhoitaja on nimetty',
          case: 'Tapaus',
          caseAssigned: 'Sinulle annettu tapaus',
          caseImporterJobCompleted: {
            PartialSuccess: 'Tapauksesi tuonti suoritettiin virheiden kanssa',
            failure: 'Tapauksesi tuonti epäonnistui',
            success: 'Tapauksesi tuonti onnistui onnistuneesti',
          },
          caseLinked: 'Liitetty tapaus',
          caseTeamInvite: 'Lisätty tapaukseen',
          caseUnlinked: 'Tapaus katkaistu',
          dataSanitisation: 'Raportin tiedot päivitetty',
          emptyDescription: 'Tarkista myöhemmin uusia ilmoituksia varten',
          emptyTitle: 'Olet ajan tasalla',
          importId: 'Tuonti-ID:',
          learnMore: 'Opi lisää',
          markAllAsRead: 'Merkitse kaikki luetuksi',
          newMessage: 'Uusi viesti',
          newReport: 'Uusi raportti vastaanotettu',
          permissionRemoved: 'Poistettu tapauksesta',
          postSSubmissionFile: 'Todiste tiedosto(t) lisätty',
          report: 'Raportti',
          reportAssigned: 'Sinulle annettu raportti',
          reportStatusChange: 'Raportin tila muuttunut',
          reporterAnonymised: 'Yksityiskohdat on anonymisoitu',
          reporterReportSubmitted: {
            subtitle: 'Suosittelemme tallentamaan kopion raportistasi',
            title: 'Raportti jätetty',
          },
          mitigationPlanReminder:
            'Lieventämissuunnitelman hyväksyntä vaaditaan',
          staleCase: 'Toimimaton tapaus',
        },
        privacyStatement: 'Yksityisyyden suojan lausunto',
        reporter: {
          myReports: 'Raporttini',
        },
        settings: 'Asetukset',
        technicalSupport: 'Tekninen tuki',
        title: 'Tili',
      },
      time: {
        day: 'Päivä',
        days: 'Päivät',
        hour: 'Tunti',
        hours: 'Tunnit',
        minute: 'Minuutti',
        minutes: 'Minuutit',
        second: 'Sekunti',
        seconds: 'Sekunnit',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Anonyymi',
        autoTranslate: 'Automaattinen käännös on oletusarvoisesti pois päältä.',
        backToMessages: 'Takaisin viesteihin',
        caseSettings: 'Tapausasetukset.',
        changeInProfile:
          'Jos haluat muuttaa tätä asetusta, voit tehdä sen profiilissasi',
        deletedByMessage: 'Poisti {{author}}',
        deletedMessageLabel: 'Tämä viesti on poistettu',
        description:
          'Kun automaattinen käännös on päällä, kaikki raporttiviestit käännetään\n          automaattisesti tekoälyä hyödyntäen, valitsemasi selaimen oletuskielellä.',
        descriptionSecondHalf:
          'Kaikkien viestien alkuperäinen versio säilyy aina ja sen voi löytää chatista.',
        messagePlaceholder: 'Aloita kirjoittaminen...',
        messageSettings: 'Viestien asetukset.',
        originalMessages: 'Alkuperäinen',
        showMoreBanner: 'Lisätietoja automaattisista käännöksistä',
        titlev2: 'Lue kaikki viestit valitsemallasi kielellä.',
        translatedMessageLabel: 'Käännetty viesti',
        translatedMessages: 'Käännetty',
        understood: 'Ymmärretty',
      },
      Country: {
        description: 'Missä maassa työskentelette?',
        header: 'Missä maassa työskentelette?',
        noOptions: 'Ei maita löydetty',
        other: 'Muu',
        placeholder: 'Hae maata...',
      },
      CreatePublicReport: {
        createReport: 'Luo uusi raportti',
        helpPage: 'Mene apusivullemme',
        loginToOpr: 'Kirjaudu seuraamaan raportteja',
        or: 'tai',
        passwordPlaceholder: 'Anna salasana',
        phoneNumberLoginFailed:
          'Kirjautuminen epäonnistui, puhelinnumero/PIN-koodi väärin',
        phoneNumberPlaceholder: 'Anna puhelinnumerosi',
        phoneNumberTooltip:
          'Anna puhelinnumero, jota käytit VaultTalk yhteydenottoon.',
        pinPlaceholder: 'Syötä PIN',
        reportIntroductionParagraph1:
          'Kun raportoit tapahtumasta, sinulle esitetään muutama kysymys, jotka auttavat sinua dokumentoimaan kokemuksesi.',
        reportIntroductionParagraph2:
          'Ennen lähettämistä, sinulla on mahdollisuus pysyä anonyyminä suojellaksesi yksityisyyttäsi.',
        reportIntroductionParagraph3:
          'Voit kirjautua sisään milloin tahansa nähdäksesi raporttisi etenemisen ja keskustellaksesi tapauksenhoitajan kanssa, kun olet lähettänyt.',
        reportIssue: 'Raportoi ongelmasta',
        usernameLoginFailed:
          'Kirjautuminen epäonnistui, käyttäjänimi/salasana väärin',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired:
              'Yritykseen liittyvä suhde on pakollinen',
            reportedCategoryRequired: 'Ilmoitetun kategorian on oltava.',
          },
        },
        vaultId: 'Vaultin ID',
        vaultIdPlaceholder: 'Syötä sähköpostisi tai Vault ID',
        vaultIdTooltip:
          'Anonyymeille raporteille Vault ID on alfanumeerinen. Jos raportti ei ollut anonyymi, Vault ID on sähköpostiosoitteesi.',
        vaultTalk: 'VaultTalk',
        yourPassword: 'Salasanasi',
        yourPhoneNumber: 'Puhelinnumerosi',
        yourPin: '6-numeroinen PIN-koodisi',
        yourVaultId: 'Vault-tunnuksesi',
      },
      CustomHeader: {
        companyLogo: 'Yrityksen logo',
        openReporting: 'Avaa raportointi',
        userSettings: 'Käyttäjäasetukset',
      },
      Date: {
        approximateDescription:
          'Muistatko noin päivämäärän, jolloin tapahtuma tapahtui?',
        approximatePlaceholder:
          'Esimerkiksi kuusi kuukautta sitten/viime vuonna/viime marraskuussa',
        cancel: 'peruuta',
        clear: 'tyhjennä',
        description: 'Muistatko päivämäärän, jolloin tapahtuma tapahtui?',
        header: 'Minä päivänä se tapahtui?',
        ok: 'ok',
        placeholder: 'Esimerkiksi 21. kesäkuuta 2020',
      },
      Description: {
        whatHappened: 'Mitä tapahtui?',
        whatHappenedPlaceholder: 'Kerro omin sanoin...',
        whatHappenedText: 'Kerro omin sanoin, mitä tapahtui',
      },
      Details: {
        disclaimer:
          'Nämä tiedot ilmoitetaan raportissasi. Jos haluat pysyä anonyymina, varmista, etteivät ne sisällä tunnistetietoja.',
        emailPlaceholder: 'Sähköposti (valinnainen)',
        fullNamePlaceholder: 'Koko nimi (valinnainen)',
        header: 'Omat tiedot',
        nonAnonSubtitle:
          'Anna joko nimesi tai sähköpostiosoitteesi. Jos haluat saada ilmoituksia tästä raportista, lisää sopiva sähköpostiosoite alla.',
        nonOptionalEmailPlaceholder: 'Sähköposti',
        nonOptionalFullNamePlaceholder: 'Koko nimi',
        subtitle:
          'Jos haluat saada ilmoituksia tästä raportista, lisää sopiva sähköpostiosoite alla.',
      },
      Emotion: {
        description: 'Miltä sinusta tuntui? Miten se vaikutti sinuun?',
        header: 'Miten se vaikutti sinuun?',
        placeholder: 'Aloita kirjoittaminen...',
      },
      Evidence: {
        addedHeading: 'Lisätty',
        deletedMessage: 'poistettiin',
        deletedStatus: 'Poistettu',
        failedToOpenFileMessage:
          'Tiedoston avaaminen epäonnistui. Yritä uudelleen.',
        fileStatuses: {
          infectedUpload: 'Merkitty turvatarkastuksessa',
          passedUpload: 'Hyväksytty turvatarkastus',
          pendingUpload: 'Turvallisuustarkastus meneillään',
          readyForDownload: 'Valmiina lataukseen',
        },
        mobileErrorMessage:
          'Merkityt tiedostot: lähetä viesti tapaustenhoitajallesi',
        nameHeading: 'Nimi',
        statusHeading: 'Tila',
        tableTitle: 'Todiste',
        webErrorMessage:
          'Merkityt tiedostot: Jos tiedosto(t) on merkitty, lähetä viesti tapaushallinnolle.',
      },
      FileUpload: {
        addFiles: 'Lisää tiedostoja',
        addMoreFiles: 'Lisää enemmän tiedostoja',
        confirm: 'Vahvista',
        description:
          'Tiedostojen lisääminen todisteina voi tukea tapauksesi hoitajan ratkaisutehokkuutta. Otathan huomioon tiedoston sisällön (mukaan lukien tiedoston metatiedot), jos haluat pysyä anonyyminä, ja kunnioita muiden yksilöiden oikeuksia ja sovellettavia lakeja.',
        dragDrop: 'Pudota tiedostot tähän tai',
        errorMessage:
          'Tiedosto(t) epäonnistuivat verkkovirheen vuoksi. Klikkaa alla viestiäksesi tapauksenhoitajallesi avusta.',
        fileLimit: 'Jokaisen tiedoston koon rajoitus: 100MB',
        fileUploadLimitText: 'Voit ladata vain 10 tiedostoa',
        header: 'Lisää todisteita',
        helpArticle: 'apu artikkeli',
        highlighted: 'selaa tiedostoja',
        information: 'Tuetut tiedostotyypit',
        moreInformation: 'Lisätietoja varten, katso tämä <a>apu artikkeli</a>',
        postSubmissionErrorMessage:
          "Emme voineet ladata tiedostoja järjestelmävirheen vuoksi. Valitse 'vahvista' uudelleen.",
        tooltipAudio: 'Ääni:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Dokumentit:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Kuvat:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Teksti:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Video:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'Tiedosto on liian suuri',
          invalidFileType: 'Tiedostotyyppiä ei tueta: {{extension}}',
          systemError: 'Järjestelmävirhe',
          tooManyFiles: 'Tiedostojen enimmäismäärä on {{maxFiles}}',
        },
        uploadFiles: 'Lataa tiedostoja',
      },
      Loading: {
        loading: 'Odota hetki, kun lähetämme raporttisi tapaushallinnalle...',
        postSubmissionLoading: 'Odota, kun lähetämme tiedosto(t)...',
      },
      Location: {
        description: 'Missä se tapahtui?',
        header: 'Missä se tapahtui?',
        placeholder: 'Esimerkiksi toimistossa',
      },
      MessageListBox: {
        messageCaseManager: 'Lähetä viesti tapauksen käsittelijälle',
        report: 'Raportti {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Käännös poistettu käytöstä',
        enableTranslationLabelEnabled: 'Käännös käytössä',
        enableTranslationsDescription:
          'Ota automaattiset käännökset käyttöön ja lue kaikki raporttiviestit haluamallasi kielellä. Käännetty kieli perustuu laitteellasi valittuun kieleen.',
        enableTranslationsHeader:
          'Ota automaattinen käännös käyttöön raporttiviesteille',
        enableTranslationsSubDescriptionv2:
          'Voit vaihtaa käännöksen ja alkuperäisen kielen välillä jokaisessa chatissa.',
        updateTranslationFailed: 'Päivityskäännös epäonnistui',
        updateTranslationSuccess: 'Käännösasetus päivitetty onnistuneesti',
      },
      Password: {
        changePasswordHeader: 'Vaihda salasana',
        createNewPassword: 'Luo uusi salasana',
        createPasswordHeader: 'Salasanasi',
        currentPasswordPlaceholder: 'Annan nykyinen salasana',
        description:
          'Kelvollisessa salasanassa on oltava vähintään 9 merkkiä ja yksi iso kirjain ja yksi numero',
        enterCurrentPassword: 'Anna nykyinen salasana',
        forgottenPasswordInstructions:
          'Anna alfanumeerinen Vault ID:si (ei sähköpostiosoitteesi) ja sähköpostiosoitteesi nollataksesi salasanasi.',
        newDescription:
          'Luo vahva salasana pitääksesi tilisi turvallisena. Aloita kirjoittaminen nähdäksesi ohjeet alla.',
        passwordPlaceholder: 'Luo salasana',
        passwordResetRequestedDescription:
          'Jos Vault ID:si on olemassa järjestelmässämme, saat sähköpostitse ohjeet salasanasi nollaamiseksi.',
        passwordResetRequestedHeader: 'Salasanan nollauslinkkiä pyydetty',
        reenterPlaceholder: 'Anna salasana uudelleen',
        subtitle:
          'Luo salasana tämän raportin lähettämiseksi ja sen myöhempää käyttöä varten',
        yourVaultId: 'Vault-tunnuksesi',
        yourVaultIdPlaceholder: 'Syötä Vault ID:si (esim. {{exampleId}})',
      },
      Perpetrators: {
        description:
          'Raportoitko tietystä henkilöstä vai useista henkilöistä? Voitko nimetä heidät tai kuvailla heitä?',
        header: 'Osallisena olevat ihmiset',
        placeholder:
          'Aloita kirjoittaminen ja erottele pilkulla useat nimet tai kuvaukset',
      },
      PoweredByVault: 'Palvelun tarjoaa {{company}}',
      PrivacyStatement: 'Tuotteen tietosuojaseloste',
      PublicMessageList: {
        myMessages: 'Omat viestit',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader:
          'Todisteita lisätty olemassa olevaan raporttiin',
        backToReportId: 'Takaisin raporttiin ID: {{reportId}}',
        description:
          'Lisäämällä tiedostoja todisteina voi tukea tapauksesi käsittelijän tehokkuutta. Ole hyvä ja harkitse tiedoston sisältöä (mukaan lukien tiedoston metatiedot), jos haluat pysyä anonyymina, ja kunnioita muiden yksilöiden oikeuksia ja sovellettavia lakeja. Lisätietoja varten, ole hyvä ja katso tämä <a>apu artikkeli</a>',
        header: 'Lisää lisänäyttöä raporttiin',
        vaultTalkOpenCaseHeader: 'Lisää todisteita raporttiisi',
      },
      PublicReport: {
        anonymous: 'Anonyymi',
        backToReports: 'Takaisin raportteihin',
        skipped: 'Ohitettu',
      },
      PublicReportCard: {
        addEvidence: 'Lisää lisänäyttöä',
        messageCaseManager: 'Lähetä viesti tapauksen käsittelijälle',
        reportId: 'Raportin tunnus:',
        submitted: 'Lähetetty',
        vaultTalkClosedCaseCTA: 'Näytä todisteet',
        vaultTalkOpenCaseCTA: 'Lisää todisteita',
        viewAdditionalEvidence: 'Näytä lisänäyttöä',
        viewReport: 'Näytä raportti',
      },
      PublicReportsList: {
        reportingSystem: 'Raportointijärjestelmä',
      },
      Question: {
        placeholder: 'Aloita kirjoittaminen...',
        question: 'Antaa yksityiskohtia',
        questionText:
          'Ole hyvä ja jaa huolesi, päivityksesi tai tiedustelusi kanssamme.',
      },
      Relationship: {
        header: 'Suhteesi organisaatioon',
        tellUsAbout: 'Kerro suhteestasi organisaatioon.',
      },
      ResponsiveNavMenu: {
        messages: 'Viestini',
        reports: 'Omat raporttini',
      },
      Site: {
        description: 'Missä toimipisteessä työskentelette?',
        header: 'Missä toimipisteessä työskentelette?',
        noOptions: 'Toimipisteitä ei löytynyt',
        other: 'Muu',
        placeholder: 'Hae toimipistettä...',
      },
      SpamPuzzle: {
        dialog: 'Jatka ratkaisemalla tämä palapeli',
      },
      SubmissionTypes: {
        reportIssue: 'Valitse kategoria',
        whatType: 'Valitse raporttiasi parhaiten kuvaava luokka',
      },
      SubmitSuccess: {
        category: '<bold>Kategoria:</bold> {{category}}',
        country: '<bold>Maa:</bold> {{country}}',
        dateSubmitted: '<bold>Päivämäärä jätetty:</bold> {{date}}',
        recordYourVaultID: 'Muista tämä tieto sisäänkirjautumista varten',
        successInformation: 'Lisätietoja',
        successMessage:
          'Raporttisi on lähetetty ja se on valmis tarkasteltavaksi. Kaikki liitetyt tiedostot, jotka vaativat huomiota, merkitään kirjautumisen yhteydessä. Kirjaudu alla nähdäksesi raporttipäivitykset ja lähettääksesi viestin tapaustenhoitajallesi.',
        successSanitationMessage:
          'Tallenna kopio omiin arkistoihisi ja pidä Vault-ID:si turvassa - tarvitset sitä päästäksesi käsiksi päivityksiin ja viestittääksesi tapauksesi hoitajalle.',
        successSanitationTagline:
          'Raporttisi on jätetty ja se on turvallisesti säilytetty.',
        successThankYou: 'Kiitos raportistasi!',
        viewReport: 'Näytä raportti',
      },
      Time: {
        approximateDescription:
          'Muistatko noin kellonajan, jolloin tapahtuma tapahtui?',
        approximatePlaceholder: 'Esimerkiksi aamulla, iltapäivällä',
        description: 'Muistatko kellonajan, jolloin tapahtuma tapahtui?',
        header: 'Mihin aikaan se tapahtui?',
        invalidTime: 'Ajan täytyy olla muodossa HH:MM',
      },
      UserSettingsDialog: {
        changePassword: 'Vaihda salasana',
        closeDialog: 'Sulje valintaikkuna',
        logout: 'Kirjaudu ulos',
        messageSettings: 'Viestiasetukset',
        userSettings: 'Käyttäjäasetukset',
      },
      Witnesses: {
        description:
          'Kerroitko asiasta kenellekään tai näkikö joku, mitä tapahtui?',
        header: 'Oliko silminnäkijöitä?',
        placeholder: 'Aloita kirjoittaminen...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Lähetä viesti',
        title: 'Viestin tapaustenhoitaja',
        translationHeader: 'Lisätietoja automaattisista käännöksistä',
      },
      ReportCard: {
        addEvidence: 'Lisää todisteita',
        submissionModeVia: 'kautta {{submissionMode}}',
        viewEvidence: 'Näytä todisteet',
      },
      ReportList: {
        yourReports: 'Raporttisi',
      },
      ReportingActivate: {
        buttonText: 'Jatka',
        description:
          'Jos organisaatiosi on rekisteröinyt sinut tilille, lähetämme sinulle sähköpostilla ohjeet asennuksen viimeistelyyn.',
        emailInput: 'Sähköposti',
        header: 'Anna työsi sähköpostiosoite',
        successAccount:
          'Jos organisaatiosi on rekisteröinyt sinut tiliin, lähetämme sinulle sähköpostin ohjeilla, jotka voit täyttää asennuksen.',
        successEmail:
          'Jos et näe sitä heti, odota muutama minuutti ja päivitä sähköpostisi saapuneet-viestit.',
        successHeading: 'Kiitos',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Lisää todisteita raporttiisi',
        descriptionText:
          'Tiedostojen lisääminen todisteina voi tukea tapaushallintasi tehokkuutta. Huomioi tiedoston sisältö (mukaan lukien tiedoston metatiedot), jos haluat pysyä nimettömänä, ja kunnioita muiden yksilöiden oikeuksia ja sovellettavia lakeja. Lisätietoja on saatavilla tästä <a>ohjeartikkelista</a>',
        emptyMessage: 'Ei lisänäyttöä ladattu',
      },
      ReportingChangePassword: {
        back: 'Takaisin',
        description:
          'Luo vahva salasana pitääksesi tilisi turvallisena. Aloita kirjoittaminen nähdäksesi ohjeet alla.',
        errorToast: 'Ei voida luoda salasanaa, virheellinen tunnus.',
        header: 'Vaihda salasana',
        incorrectCurrentPassword:
          'Nykyinen salasana on väärä. Tarkista se ja yritä uudelleen.',
        invalidToken: 'Virheellinen tunnus',
        passwordUpdated: 'Salasana päivitetty',
        passwordUpdatedDescription:
          'Salasanasi on päivitetty onnistuneesti. Kiitos, että teit tämän askeleen tietojesi turvaamiseksi!',
        passwordUsedBefore: 'Salasanan uudelleenkäyttö ei ole sallittu',
        passwordUsedBeforeDescription:
          'Turvallisuutesi vuoksi et voi käyttää uudelleen mitään kuudesta viimeisimmästä salasanastasi. Valitse uusi, ainutlaatuinen salasana pitääksesi tilisi turvallisena ja yritä uudelleen.',
        toastDescription:
          'Salasanasi on päivitetty onnistuneesti. Kiitos, että teit tämän askeleen tietojesi turvaamiseksi!',
        toastMessage: 'Salasana päivitetty',
        updatePasswordCTA: 'Päivitä salasana',
      },
      ReportingConnect: {
        cancelButton: 'Peruuta',
        connectButton: 'Yhdistä',
        disclaimer:
          'Yhdistämällä Slack-tilisi Vault-tiliisi varmistat turvallisen ja yksityisen yhteyden.<br /><br />Yhdistämisen jälkeen voit ilmoittaa väärinkäytöksistä tai esittää kysymyksen suoraan Slackissa. Sinulla on aina mahdollisuus raportoida anonyymisti yhdistämisen jälkeen. Yksityisyytesi ja turvallisuutesi ovat meille tärkeimmät prioriteetit.',
        heading:
          'Vault Platform pyytää lupaa päästä käsiksi {{organisationName}} Slack-tiliisi',
        listHeading: 'Mitä Vault pystyy tekemään?',
        permissionIdentity: {
          extraInfo:
            'Vaultilla on mahdollisuus nähdä Slack-käyttäjäsi identiteetti.',
          heading: 'Näytä tietoja käyttäjän identiteetistä',
        },
        permissionNotifications: {
          extraInfo:
            'Vault pystyy lähettämään sinulle ilmoituksia Slack-tilillesi liittyen mahdollisiin päivityksiin jätettyyn raporttiin tai kysymykseen.',
          heading: 'Lähetä sinulle ilmoituksia',
        },
        permissionOverview: {
          extraInfo:
            'Vault esittää yleiskatsauksen kaikista lähetyksistä kotisivulla',
          heading: 'Yhteenveto esityksistä',
        },
        permissionSubmitReport: {
          extraInfo:
            'Tämä myöntää Vaultille luvan lähettää raportin tai esittää kysymyksen suoraan organisaatiollesi Slackista.',
          heading: 'Lähetä raportti tai kysymys puolestasi',
        },
        successfulConnectionDescription:
          'Vault-tilisi ja Slack-tilisi on nyt yhdistetty. Voit nyt sulkea tämän välilehden ja palata Slackiin.',
        successfulConnectionHeading: 'Onnistuneesti yhdistetty',
        unsuccessfulConnectionDescription:
          'Jotain meni pieleen. Sulje tämä välilehti ja palaa Slackiin yrittääksesi uudelleen.',
        unsuccessfulConnectionHeading: 'Yhteys epäonnistui',
      },
      ReportingForgotPassword: {
        description:
          'Anna sähköpostiosoite, joka on yhdistetty tilisi kanssa, ja lähetämme sinulle linkin salasanan uudelleenasettamiseksi.',
        heading: 'Unohdettu salasana',
        invalidTokenError:
          'Salasanan luominen ei onnistu, virheellinen tunnus.',
        passwordReuseError: 'Salasanan uudelleenkäyttö ei ole sallittu',
        passwordReuseErrorDescription:
          'Turvallisuutesi vuoksi et voi käyttää uudelleen kuutta viimeisintä salasanaasi. Valitse uusi, ainutlaatuinen salasana pitääksesi tilisi turvallisena ja yritä uudelleen.',
        sendLink: 'Lähetä nollauslinkki',
        sendLinkFailure: 'Jotain meni pieleen',
        sendLinkFailureDescription:
          'Palaa takaisin <a>Reporter Hub</a>:iin ja yritä uudelleen. Jos ongelma jatkuu, ota meihin yhteyttä osoitteessa <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'Salasanan palautuslinkki lähetetty',
        sendLinkSuccessDescription:
          'Olemme lähettäneet salasanan nollauslinkin osoitteeseen {{email}}',
        updatePasswordSuccess: 'Salasana päivitetty',
        updatePasswordSuccessDescription:
          'Salasanasi on päivitetty onnistuneesti. Kiitos, että otit tämän askeleen tietojesi turvaamiseksi!',
      },
      ReportingLogin: {
        accountFrozen: 'Tili on jäädytetty',
        accountLocked:
          'Kirjautumista on yritetty liian monta kertaa virheellisesti. Tili on lukittu enintään 1 tunniksi. Salasanan nollaus ei ole mahdollista tänä aikana.',
        accountLockedPermanently:
          'Tilisi on lukittu. Käytä salasanan nollausta saadaksesi jälleen pääsyn tai ota yhteyttä järjestelmänvalvojaasi saadaksesi lisäapua.',
        createAccountCTA: 'Rekisteröidy tilille',
        currentPassword: 'Nykyinen salasana',
        emailLabel: 'Sähköpostisi',
        forgotPassword: 'Unohditko salasanasi?',
        loginButton: 'Kirjaudu sisään',
        newPasswordPlaceholder: 'Uusi salasana',
        passwordFailMessage:
          'Palaa takaisin Vault-sovellukseen Slackissä ja yritä uudelleen. Jos ongelma jatkuu, ota yhteyttä meihin osoitteessa techsupport@vaultplatform.com',
        passwordFailTitle: 'Jotain meni pieleen',
        passwordLabel: 'Sinun salasanasi',
        passwordPlaceholder: 'Syötä salasanasi',
        passwordResetRequired: 'Salasanan nollaaminen vaaditaan',
        passwordSuccessfullySetMessage:
          'Palaa takaisin Slackissa olevaan Vault-sovellukseen ja todenna uudella salasanallasi jatkaaksesi siitä, mihin jäit.',
        passwordSuccessfullySetTitle: 'Salasana asetettu onnistuneesti',
        reenterPlaceholder: 'Kirjoita salasana uudelleen',
        title: 'Toimittaja Hub',
        tooltip:
          'Jos et ole vielä asettanut salasanaa Vault-sovellukselle, seuraa tästä päästäksesi alkuun. Jos olet unohtanut salasanasi, käytä alla olevaa "Unohditko salasanan" -linkkiä.',
        usernameLoginFailed:
          'Kirjautuminen epäonnistui, käyttäjätunnus tai salasana on virheellinen',
      },
      ReportingReset: {
        failureDescription:
          'Palaa takaisin Vault-sovellukseen Slackissa ja yritä uudelleen. Jos ongelma jatkuu, ota yhteyttä meihin osoitteessa <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'Jotain meni pieleen',
        successDescription:
          'Palaa takaisin Vault-sovellukseen Slackissa ja tunnistaudu uudella salasanallasi jatkaaksesi siitä, mihin jäit.',
        successHeading: 'Salasana asetettu onnistuneesti',
      },
      noReports: {
        description:
          'Kaikki lähetetyt raportit näkyvät täällä. Opi lisää tavoista, joilla voit lähettää raportin',
        descriptionHelpArticle: 'tämä ohjeartikkeli',
        errorDescription:
          'Kamppailemme raporttiesi lataamisessa. Yritä päivittää sivu.',
        errorDescriptionSecondary:
          'Jos tämä ei toimi, ota meihin yhteyttä osoitteessa',
        errorTitle: '⚠️ Hups, jokin meni vikaan',
        title: 'Sinulla ei ole vielä raportteja',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Ota automaattinen käännös käyttöön ja lue kaikki raporttiviestit haluamallasi kielellä. Käännetty kieli perustuu laitteellasi valittuun kieleen.',
          autoTranslationDescription2:
            'Voit vaihtaa käännöksen ja alkuperäisen kielen välillä jokaisessa chatissa.',
          autoTranslationTitle:
            'Ota automaattiset käännökset käyttöön raporttiviesteille',
          header: 'Viestiasetukset',
          subHeader: 'Määritä, miten viestit näytetään',
        },
        notificationSettings: {
          emailDescription:
            'Saat sähköposti-ilmoituksia tärkeistä päivityksistä raportteihisi',
          emailTitle: 'Sähköposti-ilmoitukset',
          header: 'Ilmoitusasetukset',
          subHeader: 'Määritä, miten vastaanotat ilmoituksia',
        },
        title: 'Asetukset',
        updatedSettingsFailure: 'Päivitys asetuksiisi epäonnistui',
        updatedSettingsSuccess: 'Asetuksesi päivitys onnistui',
      },
    },
    validators: {
      passwordLength: 'Salasanassa on oltava vähintään 9 merkkiä',
      passwordLowercase: 'Salasanassa on oltava vähintään 1 pieni kirjain',
      passwordMissMatch: 'Salasana- ja vahvistuskentän on vastattava toisiaan.',
      passwordNumeric: 'Salasanassa on oltava vähintään 1 numero',
      passwordUppercase: 'Salasanassa on oltava vähintään 1 iso kirjain',
    },
    validatorsNew: {
      passwordLength: 'Välillä 10 ja 30 merkkiä',
      passwordLowercase: 'Vähintään yksi pieni kirjain',
      passwordMissMatch: 'Salasanat eivät täsmää',
      passwordNumeric: 'Vähintään yksi numero',
      passwordSpecialCharacter: 'Vähintään yksi erikoismerkki',
      passwordUppercase: 'Vähintään yksi iso kirjain',
    },
  },
};

export default translations;
